import React from 'react';
import { Button } from 'primereact/button';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBandcamp, faDeezer, faSpotify } from '@fortawesome/free-brands-svg-icons';

const Socials = () => {
    const navigate = useNavigate();

    return (
        <>
            <Link to='https://www.instagram.com/panasea.band?igsh=MWtjdmYzMGpvaGZ6MQ==' target="_blank" rel="noopener noreferrer" className='pr-2'>
                <i className="pi pi-instagram text-red-600" style={{ fontSize: '2rem' }}></i>
            </Link>
            <Link to='https://www.facebook.com/share/1Y496KA8sr/?mibextid=wwXIfr' target="_blank" rel="noopener noreferrer" className='pr-2'>
                <i className="pi pi-facebook text-blue-700" style={{ fontSize: '2rem' }}></i>
            </Link>
            <Link to='https://youtube.com/@panaseaband?feature=shared' target="_blank" rel="noopener noreferrer" className='pr-2'>
                <i className="pi pi-youtube text-red-700" style={{ fontSize: '2rem' }}></i>
            </Link>
            <Link to='https://link.deezer.com/s/34rBWuyVKzZHcseoHhttE' target="_blank" rel="noopener noreferrer" className='pr-2 text-blue-600'>
                <FontAwesomeIcon icon={faDeezer} size="2x" />
            </Link>
            <Link to='https://open.spotify.com/artist/5lsKtqbcMARJgp4oKAlC2W?si=URSwxWRAR5KYV8gw89OQ-Q' target="_blank" rel="noopener noreferrer" className='pr-2 text-green-600'>
                <FontAwesomeIcon icon={faSpotify} size="2x" />
            </Link>
            <Link to='https://panasea.bandcamp.com/' target="_blank" rel="noopener noreferrer" className='pr-2 text-orange-600'>
                <FontAwesomeIcon icon={faBandcamp} size="2x" />
            </Link>
        </>
    );
};

export default Socials;